<template>
  <div class="hello">
    <b-container>
      <b-container>
        <b-card class="my-2 border-dark" v-for="document in parentDocuments" :key="document.index" header-slot="header">
      <b-row slot="header">
        <b-col>
          <h4 v-show="!checkShowStatus(document)" >{{ document.documenttypeName }}</h4>
          <b-form-input v-if="checkShowStatus(document)" type="text" v-model="editValue" />
        </b-col>  
        <b-col cols="3">
          <b-btn size="sm" variant="warning" v-show="!checkShowStatus(document)" @click="showEditBox(document)" >Edit</b-btn>
          <b-btn @click="showEditBox(document)" v-show="checkShowStatus(document)" size="sm" variant="warning">Cancel</b-btn>
           <b-btn v-show="checkShowStatus(document)" size="sm" variant="info" :class="{disabled: document.documenttypeName == editValue}" @click="updateDocument(document)">Update</b-btn>
          <b-btn size="sm" variant="danger" v-if="userData.role == 'admin'" :class="{disabled: filterSubDocuments(document).length > 0}"  @click="deleteSub(document)">Delete</b-btn>
        </b-col>
      </b-row>
        <b-alert variant="warning" :show="filterSubDocuments(document).length == 0">
          Users will be unable to submit documents for this Parent Category if no childern are added
        </b-alert> 
        <b-card no-body size="sm" class="my-2 border-dark pt-2" v-for="subdocument in filterSubDocuments(document)" :key="subdocument.index" >
          <b-row >
          <b-col>
          <h5  v-show="!checkShowStatus(subdocument)">{{ subdocument.documenttypeName }}</h5>
            <b-form-input v-if="checkShowStatus(subdocument)" type="text" v-model="editValue" />
        </b-col>  
        <b-col cols="3">
          <b-btn @click="showEditBox(subdocument)" v-show="!checkShowStatus(subdocument)" size="sm" variant="warning">edit</b-btn>
           <b-btn @click="showEditBox(subdocument)" v-show="checkShowStatus(subdocument)" size="sm" variant="warning">Cancel</b-btn>
           <b-btn v-show="checkShowStatus(subdocument)" size="sm" variant="info"  @click="updateDocument(subdocument, document.documenttypeName)">Update</b-btn>
           <b-btn size="sm" variant="danger" @click="deleteSub(subdocument)" >Delete</b-btn>
        </b-col>
      </b-row>
        
          



      </b-card>
      <b-card class="border-primary mx-auto w-50" header-slot="header">
        <h5><em>Add New {{ document.documenttypeName }} Sub Category</em></h5>
        <b-container>
        <b-row>
          <b-col>
        <b-form-input :placeholder="'New ' + document.documenttypeName + ' Sub Category Name'" v-model="newSubCatName" />
          </b-col>
          <b-col cols="*">
        <b-btn size="sm" class="mt-1" variant="primary" @click="addNew(document.documenttypeName)">Add New</b-btn>
          </b-col>
          </b-row>
          </b-container>
      </b-card>



      </b-card>
      <b-card class="bg-primary">
      <b-card class="border-primary" header-slot="header">
        <h5><em>Add New Document Parent Category</em></h5>
        <b-container>
        <b-row>
          <b-col>
        <b-form-input :placeholder="'New Document Parent Category Name'" v-model="newSubCatName" />
          </b-col>
          <b-col cols="*">
        <b-btn variant="primary" @click="addNew()">Add New</b-btn>
          </b-col>
          </b-row>
          </b-container>
      </b-card>
      </b-card>
      </b-container>
    </b-container>
  </div>


</template>

<script>
import { mapState } from 'vuex'
import { bus } from '../../../main'
import moment from 'moment'
import axios from 'axios'
export default {
  props: ['taxData'],
  name: 'hello',
  components: { 


  },
  data () {
    return {
    newSubCatName: '',
    editId: '',
    editData: false,
    editValue: ''

    }
  },
  created(){
    
  },
  computed: {
      ...mapState([
        'userData',
        'documentTags',
        'shiftsData',
        'eventTags',
        'documentType',
        'departmentRanks',
        'departmentSpecialties',
        'vehicleCheckDetails',
        'vehicleCheckItems',
        'workgroupData',
        'getSessionData'
      ]),
      parentDocuments(){
        return this.taxData.filter( p => {
          return p.documenttypeParent == '' || p.documenttypeParent == undefined || p.documenttypeParent == null
        })
      },
      testUserRights(){
        if(this.userData.role == 'adminchief'
          || this.userData.role == 'admin'){
            return false
          } else {
            return true
          }
      },

      /*

      How to filter against two arrays

      docArray(){
        var loaded = [... new Set(this.documentsApi.map(p => p.field_document_id))]
        var bulk = [... new Set(this.docArrayPre.map(p => p.field_document_id))]
        var test = this.docArrayPre
        console.log(loaded)
        console.log(bulk)
        for(var i = 0; i < loaded.length; i++){
          var index = bulk.indexOf(loaded[i])
          if(index > -1){
          test.splice(index, 1)}
        }
        return test

      } */
  },
  watch: {

},
  methods: {
    showEditBox(document){
      if(this.editId == ''){
        this.editId = document.id
        this.editValue = document.documenttypeName
      } else if (document.id != this.editId){
        this.editId = document.id
         this.editValue = document.documenttypeName
      } else {
        this.editId = ''
         this.editValue = ''
      }
      
    },
    checkShowStatus(document){
        if(document.id != this.editId){
          return false
        } else {
          return true
        }
      },
    filterSubDocuments(data){
      return this.taxData.filter( p => {
        if(p.documenttypeParent != '' && p.documenttypeParent != undefined && p.documenttypeParent != null){
          return p.documenttypeParent == data.documenttypeName
        }
      })
    },
    addNew(parent){
      console.log(parent)
    if(parent == undefined){
      var parent = ''}
     var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'documenttype', headers: headers, expire: true}
    axios({
      method: 'post',
      url: '/api/v1/taxonomy/documenttype/',
      data: {
        'documenttypeName': this.newSubCatName,
        'documenttypeParent': parent
      },
        headers: payload.headers.headers,
      }).then(response => {
      this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
          this.newSubCatName = ''
  
      })
    
    },
    deleteSub(document){
      var result = confirm('Are You Sure You Want to Delete ' + document.documenttypeName + ' ?')
      if (result) {
      var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'documenttype', headers: headers, expire: true}
    axios({
      method: 'delete',
      url: '/api/v1/taxonomy/documenttype/' + document.id,
      headers: payload.headers.headers,
      }).then(response => {
      this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
  
      })
    } else {}
    },
    updateDocument(document, parent){
      console.log(document)
      console.log(parent)
      if(parent == undefined){
        parent = ''
        var setParent = document.documenttypeName
        var childDocuments = this.taxData.filter( p => {
        if(p.documenttypeParent != '' && p.documenttypeParent != undefined && p.documenttypeParent != null){
          return p.documenttypeParent == document.documenttypeName
        }
        })
      }
     var headers = { headers: { 'content-type': 'application/json', 'Authorization': this.getSessionData } }
     var payload = { taxonomy: 'documenttype', headers: headers, expire: true}
      axios({
        method: 'patch',
        url: '/api/v1/taxonomy/documenttype/' + document.id,
        data: {
          'documenttypeName': this.editValue,
          'documenttypeParent': parent
        },
        headers: payload.headers.headers,
      }).then(response => {
        if(parent == ''){
          for(var i = 0; i < childDocuments.length;){
            var count = 1
            var counter = childDocuments.length
            axios({
              method: 'patch',
              url: '/api/v1/taxonomy/documenttype/' + childDocuments[i].id,
              data: {
                'documenttypeName': childDocuments[i].documenttypeName,
                'documenttypeParent': this.editValue
              },
               headers: payload.headers.headers,
             }).then(response => {
               count++
               if(count == counter)
              this.$nextTick(function(){
              this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
               this.editValue = ''
               this.editId = ''
                })
               })
               i++
       
          }    


        } else {
        console.log(response.data)
        this.$store.dispatch('LOAD_TAXONOMY_DATA_EXP', payload)
        this.editValue = ''
        this.editId = ''
        }
      })
    },
  
  
 },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.table th {
  text-align: center !important;
}
</style>
<style slot-scoped>
h1, h2 {
  font-weight: normal;
}
</style>